module.exports = __webpack_public_path__ + "media/images/icon-carrot-down-932cc8591844ba0555b3e62dea47614c.svg";